<template lang="html">
  <div class="joinNotice">
    <common-header></common-header>
    <div class="container">
      <h3 class="text-center">申请入会须知</h3>
      <div class="row" style="margin-bottom:10px;">
        <div class="col-sm-12 scroll border">
          <!-- <p>填写《会员登记申请表》前，请认真阅读并同意以下条款： </p>
          <p>一、申请人需具备符合申请加入的文艺家协会规定的入会条件（见“青岛文学艺术网”各文艺家协会《章程》关于入会须知章节）。</p>
          <p>二、申请要求及程序</p>
          <p>（一）“青岛文学艺术网”为申请加入文艺家协会的入会申报途径。通过该途径申请入会，实现申请、初核、审批网上完成。</p>
          <p>（二）申请人登录“青岛文学艺术网”，注册账号，登录成功后，按照内容要求如实填写个人基本信息和上传相关资料。</p>
          <p>（三）申请人网上申报资料提交成功15个工作日后，登录注册页面查看审核信息。审核结果如果显示为“初审通过”，申请人需做如下工作:</p>
          <p>1、下载打印纸质《会员登记申请表》；</p>
          <p>2、请二位所申请协会的正式会员在申请表上签字，由本人居住地的区市文联或协会加盖公章；</p>
          <p>3、将表上所列获奖证书、参展证明、发表作品的复印件和本人2张2寸证照，在初审通过的15日内一并送至所申请文艺家协会秘书长处进行复核；</p>
          <p>4、申请加入市美协、市书协和市摄协还需同时提供本人近期创作的作品2幅。</p>
          <p>5、申请加入文艺志愿者协会者，已是其他文艺家协会的会员，须在协会职务中填写清楚已经加入的协会和职务。</p>
          <p>（四）申请人请于送交纸质入会申请材料的下季度第一个月5日前，再次登录注册页面查看审核信息,审核结果如果显示为“终审通过”，请在10日内通过网上或指定方式交纳会费。缴费成功5个工作日后，可自行在网站下载电子会员证。
          </p>
          <p>三、申请人填写和提供的材料必须真实、有效、规范。如有作假，永久取消入会资格。</p>
          <p>四、会员入会原则上每季度审批一次，入会申请时间为每季度第二个月15日前，逾期列入下一季度审批。</p>
          <p>五、申请人填写并上传成功的《会员登记申请表》有效期限为一年。</p>
          <p>六、本须知有关内容在实施过程中如有调整，会及时发布公告。</p>
          <p>七、本须知由青岛市文学艺术界联合会负责解释。</p> -->
          <p>一、提交申请前，须认真阅读青岛文学艺术网站上公布的文艺家协会《章程》，确认是否符合条件。</p>
          <p>二、发展会员原则上每季度审批一次，审批时间为每季度第一个月上旬（遇节假日顺延）。</p>
          <p>三、填写信息和材料必须真实，如有作假，将永久取消入会资格。</p>
          <p>四、步骤：</p>
          <p>（一）在“青岛文学艺术网”进行账号注册，登录成功后，按照内容要求如实填写个人信息。</p>
          <p>（二）提交申请后5个工作日内，初审结果以短信形式发送申请人手机。</p>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="form-group">
          <div class="custom-control custom-checkbox mb-3">
            <input type="checkbox" class="custom-control-input" id="customControlValidation1" v-model="checked">
            <label class="custom-control-label" for="customControlValidation1">我已阅读入会须知</label>
          </div>
        </div>

      </div>
      <div class="row justify-content-md-center">
        <div class="form-group">
          <div class="btn btn-primary" :class="!checked ? 'disabled' : ''" @click="agree">
            同意并继续
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonHeader from './header.vue'
export default {
  data() {
    return {
      checked: false
    }
  },
  components: {
    commonHeader
  },
  methods: {
    agree() {
      if (this.checked) {
        this.$router.push('/apply')
      }
    }
  }

}
</script>

<style lang="css">
.joinNotice .container {
  padding: 40px 0;
}

.joinNotice .container .row {
  margin-right: 0px;
  margin-left: 0px;
  padding: 0 10px;
}

.joinNotice .scroll {
  height: 500px;
  overflow: scroll;
  border-radius: 5px;
  background: #fff;
  margin-top: 20px;
  padding: 40px;
  font-size: 15px;
  line-height: 26px;
  color: #33434b;
}

.joinNotice .scroll p {
  text-indent: 2rem;
  font-size: 14px;
  line-height: 1.5;
}

.joinNotice .justify-content-md-center {
  -ms-flex-pack: center !important;
  -webkit-box-pack: center !important;
  justify-content: center !important;
}

.joinNotice .custom-control-input:checked~.custom-control-label::before {
  border-color: #1ab394;
  background-color: #1ab394;
}

.joinNotice .form-group {
  margin-bottom: 0;
}

.joinNotice .btn-primary {
  background-color: #18a689;
  border-color: #18a689;
  width: 200px;
}

.joinNotice .btn-primary:hover {
  background-color: #1ab394;
  border-color: #1ab394;
}

.joinNotice .btn-primary.disabled {
  opacity: 0.5;
  background-color: #18a689;
  border-color: #18a689;
}
</style>



// WEBPACK FOOTER //
// src/components/joinNotice.vue